exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content .modal-body .form-group {\r\n    overflow: initial !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/dynamicStyle.component.css
// module id = ../../../../../src/app/private/sxfdesigner/components/shared/dynamicStyle.component.css
// module chunks = main